module.exports = __webpack_public_path__ + "static/media/charger-pin-default-hover.98e95650.svg";